import React, { Component } from 'react';
import { PropTypes as PT } from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import browserUtils from '../../utils/browserUtils';
import ModifyModal from '../ModifyModal';
import SettingsModal from '../SettingsModal';
import SuccessModal from '../SuccessModal';
import './Modal.css';

export const MODIFY_MODAL = 'MODIFY_MODAL';
export const SETTINGS_MODAL = 'SETTINGS_MODAL';
export const SUCCESS_MODAL = 'SUCCESS_MODAL';

class Modal extends Component {
  componentDidMount() {
    window.addEventListener('keyup', this.onKeyUp);
  }

  componentWillUnmount() {
    window.removeEventListener('keyup', this.onKeyUp);
  }

  onKeyUp = (evt) => {
    if (evt.which === 27) {
      this.handleClose();
    }
  };

  handleClickOutside = () => {
    this.handleClose();
  };

  handleClose = () => {
    if (this.props.setModal) {
      this.props.setModal(null);
    }
  };

  renderModal() {
    const { type } = this.props;

    switch (type) {
      case MODIFY_MODAL:
        return (
          <ModifyModal
            {...this.props}
          />
        );
      case SUCCESS_MODAL:
        return (
          <SuccessModal
            {...this.props}
          />
        );
      case SETTINGS_MODAL:
        return (
          <SettingsModal
            {...this.props}
          />
        );
      default:
        return (<div />);
    }
  }

  render() {
    const { setModal } = this.props;

    return (
      <div className={`modal ${browserUtils.IE ? 'IE' : ''}`}>
        {setModal && <button
          className="icon icon-cancel cancelButton"
          onClick={() => {
            this.handleClose();
          }}
        />}
        {this.renderModal()}
      </div>
    );
  }
}

Modal.propTypes = {
  type: PT.string,
  contact: PT.object,
  setModal: PT.func
};

export default onClickOutside(Modal);



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js